var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "form-inbox" } }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "pagination-controls" }, [
        _c(
          "button",
          {
            attrs: { disabled: _vm.answersData.currentPage === 1 },
            on: { click: _vm.prevPage },
          },
          [_vm._v("Önceki")]
        ),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "Sayfa " +
              _vm._s(_vm.answersData.currentPage) +
              " / " +
              _vm._s(_vm.answersData.totalPages)
          ),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            attrs: {
              disabled:
                _vm.answersData.currentPage >= _vm.answersData.totalPages,
            },
            on: { click: _vm.nextPage },
          },
          [_vm._v("Sonraki")]
        ),
        _vm._v(" "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.localPageSize,
                expression: "localPageSize",
              },
            ],
            on: {
              change: [
                function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.localPageSize = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
                _vm.changePageSize,
              ],
            },
          },
          [
            _c("option", { attrs: { value: "5" } }, [_vm._v("5 öğe/sayfa")]),
            _vm._v(" "),
            _c("option", { attrs: { value: "10" } }, [_vm._v("10 öğe/sayfa")]),
            _vm._v(" "),
            _c("option", { attrs: { value: "20" } }, [_vm._v("20 öğe/sayfa")]),
            _vm._v(" "),
            _c("option", { attrs: { value: "50" } }, [_vm._v("50 öğe/sayfa")]),
            _vm._v(" "),
            _c("option", { attrs: { value: "100" } }, [
              _vm._v("100 öğe/sayfa"),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "header-item",
          on: {
            click: function ($event) {
              return _vm.$router.push({
                path: "/form",
                query: { type: "list" },
              })
            },
          },
        },
        [
          _c("md-icon", { staticClass: "icon" }, [_vm._v("arrow_back")]),
          _vm._v(" "),
          _c("span", { staticClass: "header-text" }, [_vm._v("Geri")]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "header-item",
          on: {
            click: function ($event) {
              return _vm.filterStatusForm("notRead")
            },
          },
        },
        [
          _c("md-icon", { staticClass: "icon" }, [_vm._v("inbox")]),
          _vm._v(" "),
          _c("span", { staticClass: "header-text" }, [
            _vm._v("Gelen Kutusu (" + _vm._s(_vm.answersData.notRead) + ")"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "header-item",
          on: {
            click: function ($event) {
              return _vm.filterStatusForm("read")
            },
          },
        },
        [
          _c("md-icon", { staticClass: "icon" }, [_vm._v("send")]),
          _vm._v(" "),
          _c("span", { staticClass: "header-text" }, [
            _vm._v("Okundu (" + _vm._s(_vm.answersData.read) + ")"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "header-item",
          on: {
            click: function ($event) {
              return _vm.filterStatusForm("archive")
            },
          },
        },
        [
          _c("md-icon", { staticClass: "icon" }, [_vm._v("archive")]),
          _vm._v(" "),
          _c("span", { staticClass: "header-text" }, [
            _vm._v("Arşiv (" + _vm._s(_vm.answersData.archive) + ")"),
          ]),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "inbox-menu" },
        [
          !_vm.loading
            ? _c("InboxMenu", {
                attrs: { answersData: _vm.answersData },
                on: {
                  "item-selected": _vm.formAnswers,
                  "change-page": _vm.changePage,
                  "change-page-size": _vm.changePageSize,
                },
              })
            : _c("div", { staticClass: "spinner" }, [
                _c(
                  "svg",
                  {
                    staticClass: "spinner-icon",
                    attrs: {
                      width: "50px",
                      height: "50px",
                      viewBox: "0 0 50 50",
                    },
                  },
                  [
                    _c("circle", {
                      staticClass: "path",
                      attrs: {
                        cx: "25",
                        cy: "25",
                        r: "20",
                        fill: "none",
                        "stroke-width": "5",
                      },
                    }),
                  ]
                ),
              ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "inbox-content" },
        [
          _vm.selectedAnswer
            ? _c("InboxContents", {
                attrs: {
                  "submission-id": _vm.selectedAnswer.submission._id,
                  "not-read-btn": _vm.notReadBtn,
                },
                on: { "mark-as-read": _vm.updateData },
              })
            : _c("div", [
                _vm._v(
                  "\n                Detayları görmek için bir öğe seçin.\n            "
                ),
              ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }